/*!
 * devextreme-angular
 * Version: 21.2.5
 * Build date: Mon Jan 17 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

import { NestedOption } from 'devextreme-angular-rpk/core';


export abstract class DxoVectorMapProjectionConfig extends NestedOption {
    get aspectRatio(): number {
        return this._getOption('aspectRatio');
    }
    set aspectRatio(value: number) {
        this._setOption('aspectRatio', value);
    }

    get from(): Function {
        return this._getOption('from');
    }
    set from(value: Function) {
        this._setOption('from', value);
    }

    get to(): Function {
        return this._getOption('to');
    }
    set to(value: Function) {
        this._setOption('to', value);
    }
}
